import { TeamsMeeting, User } from '../types';

interface BaseThreadScope {
  readonly subtype: ThreadScopeSubtype;
}

export enum ThreadScopeSubtype {
  UserMomentScope = 'UserMomentScope',
  UserWallScope = 'UserWallScope',
  GroupScope = 'GroupScope',
  DirectMessageScope = 'DirectMessageScope',
  TeamsMeetingScope = 'TeamsMeetingScope',
  SharePointItemScope = 'SharePointItemScope',
  BroadcastScope = 'BroadcastScope',
  TombstoneScope = 'TombstoneScope',
  NetworkQuestionScope = 'NetworkQuestionScope',
}

export interface UserMomentThreadScope extends BaseThreadScope {
  readonly subtype: ThreadScopeSubtype.UserMomentScope;
  readonly ownerId: User['id'];
}

export interface UserWallThreadScope extends BaseThreadScope {
  readonly subtype: ThreadScopeSubtype.UserWallScope;
  readonly ownerId: User['id'];
}

export interface GroupThreadScope extends BaseThreadScope {
  readonly subtype: ThreadScopeSubtype.GroupScope;
}

export interface DirectMessageThreadScope extends BaseThreadScope {
  readonly subtype: ThreadScopeSubtype.DirectMessageScope;
}

export interface TeamsMeetingThreadScope extends BaseThreadScope {
  readonly subtype: ThreadScopeSubtype.TeamsMeetingScope;
  readonly teamsMeetingId: TeamsMeeting['id'];
}

export interface SharePointItemThreadScope extends BaseThreadScope {
  readonly subtype: ThreadScopeSubtype.SharePointItemScope;
}

export interface BroadcastThreadScope extends BaseThreadScope {
  readonly subtype: ThreadScopeSubtype.BroadcastScope;
}

export interface TombstoneThreadScope extends BaseThreadScope {
  readonly subtype: ThreadScopeSubtype.TombstoneScope;
}

export interface NetworkQuestionThreadScope extends BaseThreadScope {
  readonly subtype: ThreadScopeSubtype.NetworkQuestionScope;
}

export const isThreadScopeUserStoryline = (threadScope: ThreadScope): threadScope is UserWallThreadScope =>
  threadScope.subtype === ThreadScopeSubtype.UserWallScope;

export const isThreadScopeTeamsMeeting = (threadScope: ThreadScope): threadScope is TeamsMeetingThreadScope =>
  threadScope.subtype === ThreadScopeSubtype.TeamsMeetingScope;

export const isThreadScopeUserStory = (threadScope: ThreadScope): threadScope is UserMomentThreadScope =>
  threadScope.subtype === ThreadScopeSubtype.UserMomentScope;

export const isThreadScopeNetworkQuestion = (threadScope: ThreadScope): threadScope is NetworkQuestionThreadScope =>
  threadScope.subtype === ThreadScopeSubtype.NetworkQuestionScope;

export const isThreadScopeGroup = (threadScope: ThreadScope): threadScope is GroupThreadScope =>
  threadScope.subtype === ThreadScopeSubtype.GroupScope;

export const isThreadScopeBroadcast = (threadScope: ThreadScope): threadScope is BroadcastThreadScope =>
  threadScope.subtype === ThreadScopeSubtype.BroadcastScope;

export type ThreadScope =
  | UserMomentThreadScope
  | UserWallThreadScope
  | GroupThreadScope
  | DirectMessageThreadScope
  | TeamsMeetingThreadScope
  | SharePointItemThreadScope
  | BroadcastThreadScope
  | TombstoneThreadScope
  | NetworkQuestionThreadScope;
